import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import AssociationAnalyticsDashboard from '../GdaAnalytics/AssociationAnalyticsDashboard';

function SummaryVDAGraphs({ source, view, names }) {
  useViewChangeTracker('SummaryVDAGraphs', view, 'graph');

  return <AssociationAnalyticsDashboard associationTab="VDA" source={source} view={view} names={names} />;
}

export default React.memo(SummaryVDAGraphs);
